export default __webpack_public_path__ + "static/media/solucao-05.a7a48a13.webp";